import './style.scss'
import { Drawer, Layout } from 'antd'
import { MainHeader } from './Header'
import { MainMenu } from './SideMenu'
import { useApp } from '@/hooks'
import { useSelector } from 'react-redux'
import { Loader } from '@/components'
import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'

const { Content } = Layout
export const DashboardLayout = ({ children }) => {
  const { visible, setVisible } = useApp()
  const { currentUser } = useSelector((state) => state.auth)
  const { loading } = useSelector((state) => state.common)
  const location = useLocation()
  // State to track if we are in the "Initial Load" phase of a specific route
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  // 1. Reset the "Initial Load" flag whenever the URL Path changes
  useEffect(() => {
    setIsInitialLoad(true)
  }, [location.pathname])

  useEffect(() => {
    if (!loading) {
        // Small timeout prevents flickering if loading toggles fast
        const timer = setTimeout(() => setIsInitialLoad(false), 200)
        return () => clearTimeout(timer)
    }
  }, [loading])

  const onClose = () => {
    setVisible(false)
  }
  const showGlobalLoader = loading && isInitialLoad
  return (
    // <Loader loading={loading}>
    <Layout className="main-content-layout">
      {currentUser?.username && (
        <Drawer width={320} placement="left" onClose={onClose} open={visible}>
          <div className="menu-container">
            <MainMenu />
          </div>
        </Drawer>
      )}
      <Content className="main-container">
        <MainHeader />
        <Loader loading={showGlobalLoader} pageLevel>
           {children}
        </Loader>
      </Content>
    </Layout>
    // </Loader>
  )
}
